module.exports = __webpack_public_path__ + "img/banner-header-new_04-asesoria-en-siniestros.79d3c355.jpg";